import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { DashboardKpiCard } from "src/components/common";
import type { PaidMediaOverviewPlatform } from "src/services/PaidMediaOverviewAPI";
import { getPlatformReportKpiTooltip } from "./platformReportTooltips";
import type { PlatformReportTotals } from "../../data/paidMediaPlatformReportMockData";
import { PLATFORM_REPORT_KPIS } from "./platformReportConfig";
import { formatPlatformReportValue, platformReportChangePercent } from "./platformReportFormat";

interface PlatformReportKpiGridProps {
  platform: PaidMediaOverviewPlatform;
  totals: PlatformReportTotals;
  priorTotals: PlatformReportTotals;
  clickLabel: string;
}

const PlatformReportKpiGrid: FC<PlatformReportKpiGridProps> = ({
  platform,
  totals,
  priorTotals,
  clickLabel,
}) => {
  const { t } = useTranslation();

  return (
    <div className="paid-media-kpi-grid">
      {PLATFORM_REPORT_KPIS.map(kpi => {
        const Icon = kpi.icon;
        const title = kpi.useClickLabel ? clickLabel : t(kpi.labelKey);

        return (
          <DashboardKpiCard
            key={kpi.id}
            className="paid-media-kpi-card"
            title={title}
            value={formatPlatformReportValue(totals[kpi.id], kpi.format)}
            icon={<Icon size={18} />}
            tooltip={getPlatformReportKpiTooltip(t, kpi.tooltipId, platform)}
            changePercent={platformReportChangePercent(totals[kpi.id], priorTotals[kpi.id])}
            changePercentTreatZeroAsMissing={false}
            hideNoTrendFallback
            trendPolarity={kpi.lowerIsBetter ? "lower-is-better" : "higher-is-better"}
            comparisonLabel={t("platformAdsReport.comparisonLabel")}
            metricLabelForTooltip={title}
          />
        );
      })}
    </div>
  );
};

export default PlatformReportKpiGrid;
